// removed by extract-text-webpack-plugin
module.exports = {"Home":"_2ChnR8-LxgL-4Cvm6-a15g","Form":"DNRa9sbag0ACzcIk44gRG","Category":"_3PzvKEzDx-RzEnMB2ODCxy","LatestArticle":"_3YFR9b7v2q6Ig6IFw8UO3m","Error":"_1I9GbqNW6rIm0gKAaU3-Ny"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/styles.css
// module id = 648
// module chunks = 0